
import { certificationImages } from '../../../utils/images';

export default function CertificationsSection() {
  const certifications = [
    { name: "BSCI", image: certificationImages.bsci },
    { name: "SEDEX", image: certificationImages.sedex },
    { name: "LWG", image: certificationImages.lwg },
    { name: "RDS", image: certificationImages.rds },
    { name: "GRS", image: certificationImages.grs },
    { name: "ISO 9001", image: certificationImages.iso9001 },
    { name: "ISO 14001", image: certificationImages.iso14001 }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="text-gray-600 text-sm font-light tracking-[0.2em] uppercase mb-6">
            Quality Assurance
          </div>
          <h2 className="text-5xl lg:text-6xl font-light mb-8 leading-tight">
            Our{' '}
            <span className="font-normal">
              Certifications
            </span>
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed font-light max-w-3xl mx-auto mb-12">
            We are proudly certified by these organizations, reflecting our dedication to sustainability, ethical production, and quality assurance. These certifications ensure that every product we manufacture meets the highest standards of quality, sustainability, and ethical production practices.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 lg:gap-8 items-center">
          {certifications.map((cert, index) => (
            <div key={index} className="text-center group flex-shrink-0">
              <div className="w-32 h-32 mx-auto mb-3 group-hover:scale-105 transition-all duration-300">
                <img
                  src={cert.image}
                  alt={cert.name}
                  className="w-full h-full object-contain"
                />
              </div>
            </div>
          ))}
        </div>

        </div>
    </section>
  );
}
